<template>
  <div class="other-settings">
    <div name="limit-other-settings">
      <!-- TITULO -->
      <b-row class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title__text"
        >
          Número de pessoas

          <PmwParagraph class="form--subtitle" size="paragraph-40">
            Limite que esta tarifa será ativada de acordo com o número de
            pessoas da busca. Ótima opção para direcionar as buscar para casais
            no dia dos namorados, por exemplo.
          </PmwParagraph>
        </PmwHeading>
      </b-row>

      <!-- BOTÃO DE ADICIONAR LIMITE DE PESSOAS -->
      <b-row v-if="!showPeopleInputs" class="form--row">
        <PmwButton
          :hasIcon="true"
          variation="blue-100"
          layout="outline"
          class="form--button"
          @click="showPeopleInputs = true"
        >
          Adicionar limite de pessoas
        </PmwButton>
      </b-row>

      <!-- INPUTS DE NÚMERO DE PESSOAS -->
      <b-row v-if="showPeopleInputs" class="form--row">
        <NumberOfPeople
          :fluctuationData="fluctuationData"
          :errors="errors"
          @closeInputs="showPeopleInputs = false"
        />
      </b-row>
    </div>

    <SeparateLine :top="20" :right="-10" :bottom="20" :left="-10" />

    <RateCodesForm
      :promocodes="fluctuationData.promocodes"
      :corporateRate="fluctuationData.tarifasCorporativas"
      @update:promocodes="(value) => (fluctuationData.promocodes = value)"
      @update:corporateRate="
        (value) => (fluctuationData.tarifasCorporativas = value)
      "
    />

    <SeparateLine :top="25" :right="-10" :bottom="47" :left="-10" />

    <div name="letsboo-website">
      <!-- TITULO DO SITE LETSBOOK -->
      <b-row class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title__text"
        >
          Promoção no Site Letsbook

          <PmwParagraph class="form--subtitle" size="paragraph-40">
            Exibe essa tarifa como destaque nas páginas do seu site Letsbook
          </PmwParagraph>
        </PmwHeading>
      </b-row>

      <b-row class="form--row">
        <InputCheckbox
          v-model="fluctuationData.promocao"
          :checked="fluctuationData.promocao"
          :inputValue="true"
          label="Ativar como tarifa promocional no site"
          name="hasWebsiteRates"
          class="form--input__checkbox"
        />
      </b-row>

      <div v-if="fluctuationData.promocao">
        <b-row class="form--row">
          <!-- TEXT AREA DE DESCRIÇÃO DE TARIFA -->
          <Textarea
            :value="rateDescription"
            :counter="true"
            :maxlength="1500"
            :hasLanguages="true"
            :language="language"
            :languageCodes="{ pt: 'pt-BR', en: 'en-US', es: 'es-ES' }"
            label="Descreva brevemente o que inclui essa promoção"
            placeholder=""
            class="form--textarea"
            @changeLanguage="language = $event"
            @input="updateRateDescription"
          />
        </b-row>

        <b-row class="form--row">
          <!-- UPLOAD DE IMAGEM DA PROMOÇÃO -->
          <PmwImageUpload
            v-show="!loading"
            v-model="fluctuationData.urlImagemPromocional"
            :fixedJpeg="true"
            :maxSize="1024"
            :imageWidth="560"
            :imageHeight="420"
            :inputWidth="350"
            :required="fluctuationData.promocao"
            :error="errors.includes('UrlImagemPromocional')"
            data-error="UrlImagemPromocional"
            inputTitle="Foto da Promoção"
            inputButtonText="Upload do seu computador"
            minSizeErrorText="A imagem precisa ter no mínimo a dimensão de 560x420 pixels. Tente novamente com uma imagem maior."
            sizeErrorText="A imagem selecionada excede o limite de tamanho. Tente novamente com uma imagem menor que 1MB"
            sizeInfo="Dimensão recomendada 560 x 420"
            inputDescription="São aceitos arquivos .JPG e .PNG de até 1MB."
            accept=".png, .jpg"
            inputTextBox="Arraste a imagem para cá"
            class="form--file-upload"
            @change="updateImage($event, 'promotionImage')"
          />

          <Skeleton v-show="loading" width="300px" height="255px" />
        </b-row>
      </div>
    </div>

    <SeparateLine :top="20" :right="-10" :bottom="20" :left="-10" />

    <div name="crm-groups">
      <b-row class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title__text"
        >
          Grupos CRM

          <InfoTooltip
            :tooltipMinWidth="'232'"
            text="Tarifa exclusiva para um grupo de pessoas, que será demonstrada apenas quando identificação do email."
          />

          <PmwParagraph class="form--subtitle" size="paragraph-40">
            Vincule esta tarifa a grupos do CRM.
          </PmwParagraph>
        </PmwHeading>
      </b-row>

      <b-row v-if="!showCRMGroupSelection" class="form--row">
        <PmwButton
          :hasIcon="true"
          variation="blue-100"
          layout="outline"
          class="form--button"
          @click="showCRMGroupSelection = true"
        >
          Adicionar grupos
        </PmwButton>
      </b-row>

      <b-row v-if="showCRMGroupSelection" class="form--row">
        <CRMGroupsForm
          v-model="fluctuationData"
          :showTitle="false"
          :isOpen="showCRMGroupSelection"
          :hotelId="hotelId"
          showSelectedGroupsList
        />
      </b-row>
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import SeparateLine from '@solucoes/components-lib-tmp/src/components/elements/SeparateLine'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import Skeleton from '@solucoes/components-lib-tmp/src/components/elements/Skeleton'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import Textarea from '@solucoes/components-lib-tmp/src/components/elements/Textarea'
import PmwImageUpload from '@solucoes/components-lib-tmp/src/components/patterns/PmwImageUpload'
import CRMGroupsForm from '@/components/rates/master/CRMGroupsForm'

import NumberOfPeople from './NumberOfPeople'
import RateCodesForm from '@/components/rates/master/RateCodesForm'

export default {
  name: 'OtherSettings',
  components: {
    PmwHeading,
    PmwParagraph,
    PmwButton,
    SeparateLine,
    InputCheckbox,
    InfoTooltip,
    NumberOfPeople,
    Textarea,
    PmwImageUpload,
    Skeleton,
    RateCodesForm,
    CRMGroupsForm
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    description: {
      type: Array,
      default: () => [
        {
          idioma: 'es-ES',
          descricaoPromocao: ''
        },
        {
          idioma: 'en-US',
          descricaoPromocao: ''
        },
        {
          idioma: 'pt-BR',
          descricaoPromocao: ''
        }
      ]
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      /** Linguagem selecionada */
      language: 'pt-BR',

      showPeopleInputs: false,

      showCRMGroupSelection: false,

      promotionImage: null,

      loading: false,

      hotelId: null
    }
  },

  computed: {
    /** Descrição do hotel */
    rateDescription() {
      /** Retorna a descricao do idioma selecionado */
      return (
        this.fluctuationData.idiomas.find(
          (item) => item.idioma === this.language
        )?.descricaoPromocao || ''
      )
    }
  },

  watch: {
    showPeopleInputs(newVal) {
      if (!newVal) {
        this.$emit('showInputs', newVal)
        this.fluctuationData.minimoAdultos = null
        this.fluctuationData.maximoAdultos = null
        this.fluctuationData.minimoCriancas = null
        this.fluctuationData.maximoCriancas = null
      }
    },

    'fluctuationData.gruposCrm': {
      handler() {
        if (this.fluctuationData.gruposCrm?.length > 0) {
          this.fluctuationData.tipoFlutuacao = 2
        } else if (this.fluctuationData.gruposCrm?.length <= 0) {
          this.fluctuationData.tipoFlutuacao = 0
        }
      },
      deep: true
    }
  },

  created() {
    this.hotelId = this.$route.params.id

    if (
      this.fluctuationData.minimoAdultos !== null ||
      this.fluctuationData.maximoAdultos !== null ||
      this.fluctuationData.minimoCriancas !== null ||
      this.fluctuationData.maximoCriancas !== null
    ) {
      this.showPeopleInputs = true
    }

    if (
      this.fluctuationData?.gruposCrm &&
      this.fluctuationData?.gruposCrm.length
    ) {
      this.showCRMGroupSelection = true
    }
  },

  methods: {
    /** Salvar imagem
     * @param {Image} image: Arquivo de imagem
     * @param {String} name: Nome da imagem que será alterada
     */
    updateImage(image, name) {
      /** Valida se é uma imagem */
      if (image instanceof File) {
        return this.saveImage(image, name)
      } else {
        /** Se não for, a imagem é removida */
        this.fluctuationData.urlImagemPromocional = ''
      }
    },

    /** Salvar imagem
     * @param {Image} image: Arquivo de imagem
     * @param {String} name: Nome da imagem que será alterada
     */
    saveImage(image, name) {
      this.loading = true
      const data = new FormData()
      data.append('imagem', image)
      this.$masterRates
        .image(data)
        .then((response) => {
          /** Guardar imagem salva */
          this.fluctuationData.urlImagemPromocional = response.data.url

          this.$bus.$emit('show-alert-chip', {
            message: 'Imagem salva com sucesso!'
          })
        })
        .catch((error) => {
          this.$bus.$emit('show-alert-chip', {
            message: error.messages
          })
          /** Limpar o campo de imagem */
          this.$emit(name, null)
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Atualizar o campo de textarea da descrição da tarifa
     * @param {String} value: valor do textarea
     */
    updateRateDescription($event) {
      const langMatch = this.fluctuationData.idiomas.find(
        (item) => item.idioma === this.language
      )

      if (langMatch) {
        this.$set(langMatch, 'descricaoPromocao', $event)
      } else {
        this.fluctuationData.idiomas.push({
          idioma: this.language,
          descricaoPromocao: $event
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.other-settings {
  min-width: 900px;
  .form {
    &--file-upload {
      width: 300px;

      ::v-deep {
        .pmw-form-field--label {
          font-size: font-size('size-medium');
          font-weight: font-weight('weight-medium');
        }

        .pmw-box-file {
          margin: 14px auto 14px auto;
        }
      }
    }

    &--treeview {
      margin-top: -20px;
      width: 475px;
    }

    &--subtitle {
      font-size: font-size('size-small');
      font-weight: font-weight('weight-normal');
      color: pmw-colors(grey-80);
      line-height: 21px;
      margin-top: 8px;
    }

    &--button {
      width: 225px;
    }

    &--textarea {
      width: 650px;
      ::v-deep {
        .pmw-textarea--field {
          line-height: 18px;
        }
      }
    }

    &--input {
      &__checkbox {
        width: 300px;
        max-width: 300px;
      }

      /** Alterar cores novas do select */
      ::v-deep {
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }

      &__select {
        width: 250px;
        max-width: 250px;

        &.error {
          ::v-deep {
            .pmw-select--button {
              border-bottom-color: pmw-colors('error-100');
              border-bottom-width: 2px;
            }
          }
        }
      }
    }

    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 28px;
      margin-bottom: 24px;

      &__small {
        max-width: 500px;
        gap: 0px;
        padding-top: 12px;
        margin-bottom: 32px;
      }

      &__rates {
        gap: 56px;
        margin-bottom: 46px;
      }

      &__input-rates {
        gap: 26px;
        margin-bottom: 42px;
      }
    }

    &--title {
      margin-bottom: 24px;
      min-width: auto;
      display: inline-flex;

      &__text {
        margin-bottom: 24px;
      }

      &__size {
        width: auto;
      }
    }
  }
}
</style>
